<template>
    <section class='icon-usps'>
        <div v-for="item in slice.items" :key="item.id" class="icon-usp">
            <div class="icon-usp__image">
                <prismic-image :field="item.icon_image"/>
            </div>
            <div class="icon-usp__textbox">
                <h3><prismic-rich-text :field="item.icon_title"/></h3>
                <p><prismic-rich-text :field="item.icon_text"/></p>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        props: ['slice'],
        name: 'icon_usp'
    }
</script>
<style  lang="scss">
    .icon-usps {
        display: grid;
        grid-template-columns: 50% 50%;
        grid-template-rows:  auto;

        @media (max-width: 767px) {
            grid-template-columns: 100%;
        }
    }
    .icon-usp {
        display: grid;
        grid-template-columns: 170px auto;
        grid-template-rows:  auto 50px;

        @media (max-width: 767px) {
            grid-template-columns: auto;
            grid-template-rows: auto;
            background: #F7F8FF;
            margin-bottom: 25px;
            padding: 25px;
        }
        &__image {
            width: 150px;
            margin: 10px;
            @media (max-width: 767px) {
                margin: 10px auto;
            }
        }
        &__textbox {
            width: 90%;
            h3 {
                width:100%;
                font-size: 20px;
                font-weight: bold;
                @media (max-width: 767px) {
                    text-align: center;
                    border-bottom: 1px solid #ccc
                }
            }
        }
    }
</style>
